import axios from "axios";

export const getSection2 = async () => {
  return await axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/api/about-page-s2-support?populate[Support][populate]=*&populate=Image`,
    )
    .then((response) => response.data)
    .catch((error) => error);
};
